import React from 'react';
import IdleTimer from 'react-idle-timer';
import useAuth from '../auth/context/auth';
import cognitoLogout from '../../functions/cognitoLogout';
import SessionTimeoutDialog from './SessionTimeoutDialog'

const SessionTimeout = () => {
	const { authTokens, setAuthTokens } = useAuth();
	const isLoggedIn = authTokens && authTokens.isLoggedIn;

	const onIdle = () => {
		if (isLoggedIn) {
			sessionStorage.setItem('session_timeout', 'true');
			setAuthTokens({});
			cognitoLogout();
		};
	};

	return (
		<div>
			<IdleTimer onIdle={onIdle} timeout={ 20 * 60000 } />
			<SessionTimeoutDialog />
		</div>
	);
};

export default SessionTimeout;